module.exports = __webpack_public_path__ + "static/RedBankLogo-85452767aa35f4777d46890f7d0123cb.png";